import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import React, { useContext } from "react";
import EntityOperation from "../../../infrastructure/EnumEntityOperation";
import Labels from "../../../infrastructure/Labels_sr_Latn_RS";
import { CALENDAR_DATE_FORMAT, formatCustomDate } from "../../../utils/Utils";
import CUDialogPacijent from "../../pacijent/CUDialogPacijent";
import { AppContext } from "../../Store";
import RegistarDataTable from "./RegistarDataTable";
import RegistarFilterPanel from "./RegistarFilterPanel";
import RegistarLogical from "./RegistarLogical";

export default function Registar() {
  const {
    registar,
    state,
    setState,
    podaci,
    dataTable,
    loading,
    tableRows,
    first,
    handleRowsAndFirst,
    tipoviSkupaAtributa,
    displayPacijent,
    displayUnos,
    openDialogUnos,
    openDialogPacijent,
    closeDialogUnos,
    closeDialogPacijent,
    kriterijumZaPretragu,
    searchFieldOnChange,
    handleKeyPressLogIn,
    unosiPoljaZaPretragu,
    prikaziPoljaZaPretragu,
    pretraga,
    noviUnos,
    changeState,
    changeVeza,
    changeTipaSkupaAtributa,
    changeAtributUTipuSkupa,
    changeOperator,
    dodajRedPretrage,
    obrisiRedPretrage,
    displayUnosStatus,
  } = RegistarLogical();

  const { prikazDatumaPoseban } = useContext(AppContext);
  const renderFooter = () => {
    return (
      <>
        <Button label={Labels.BUTTON_ODUSTANI} onClick={closeDialogUnos} icon="pi pi-times" className="p-button-secondary" />
        <Button label={Labels.BUTTON_KREIRAJ} onClick={noviUnos} icon="pi pi-check" className="p-button-primary" autoFocus />
      </>
    );
  };

  const createExaminationList = tipoviSkupaAtributa?.map(
    ({ value, label, maksimalanBrojInstanciPoMesecu }: { value: number; label: string; mesecAktivan?: number[]; maksimalanBrojInstanciPoMesecu?: number }) => {
      return (
        <div key={value} className="field-radiobutton col-12 py-0">
          <RadioButton
            inputId={value + ""}
            name="category"
            value={state.selectTipSkupAtributa}
            onChange={() => setState({ ...state, selectTipSkupAtributa: value, maksimalanBrojInstanciPoMesecu })}
            checked={state.selectTipSkupAtributa === value}
          />
          <label className="p-2" htmlFor={value + ""}>
            {label}
          </label>
        </div>
      );
    }
  );

  return (
    <div className="grid px-3">
      <RegistarFilterPanel
        registar={registar}
        state={state}
        podaci={podaci}
        tipoviSkupaAtributa={tipoviSkupaAtributa}
        kriterijumZaPretragu={kriterijumZaPretragu}
        searchFieldOnChange={searchFieldOnChange}
        handleKeyPressLogIn={handleKeyPressLogIn}
        unosiPoljaZaPretragu={unosiPoljaZaPretragu}
        prikaziPoljaZaPretragu={prikaziPoljaZaPretragu}
        pretraga={pretraga}
        changeState={changeState}
        changeVeza={changeVeza}
        changeTipaSkupaAtributa={changeTipaSkupaAtributa}
        changeAtributUTipuSkupa={changeAtributUTipuSkupa}
        changeOperator={changeOperator}
        dodajRedPretrage={dodajRedPretrage}
        obrisiRedPretrage={obrisiRedPretrage}
      />
      <RegistarDataTable
        dataTable={dataTable}
        loading={loading}
        tableRows={tableRows}
        first={first}
        handleRowsAndFirst={handleRowsAndFirst}
        tipoviSkupaAtributa={tipoviSkupaAtributa}
        openDialogUnos={openDialogUnos}
        openDialogPacijent={openDialogPacijent}
        displayUnosStatus={displayUnosStatus}
      />

      <Dialog header={Labels.TITLE_DIALOG_KREIRANJE_UNOSA} visible={displayUnos} footer={renderFooter} onHide={closeDialogUnos} contentStyle={{ maxWidth: "500px" }}>
        <div className="grid">
          {state.odabirDatumaPreUnosa && (
            <>
              <label className="col-12">{Labels.LABEL_DATUM_PREGLEDA}:</label>
              <div className="col-12 flex gap-3 align-items-center">
                <Calendar className="w-9" showIcon dateFormat={CALENDAR_DATE_FORMAT} value={state.vremeUnosa} onChange={(e: any) => setState({ ...state, vremeUnosa: e.value })} />
                {prikazDatumaPoseban && <div className="font-bold">{formatCustomDate(state.vremeUnosa)}</div>}
              </div>
            </>
          )}
          <label className="col-12">{Labels.LABEL_IZABERITE_TIP_PREGLEDA}:</label>
          {createExaminationList}
        </div>
      </Dialog>
      <Dialog header={Labels.LABEL_NOVI_PACIJENT} visible={displayPacijent} onHide={closeDialogPacijent} contentStyle={{ maxWidth: "1000px" }}>
        <CUDialogPacijent pacijentOperation={EntityOperation.CREATE} onCancel={closeDialogPacijent} />
      </Dialog>
    </div>
  );
}
